import React from "react";

export const trade_in_statuses = {
  'DEFAULT': 'not_started',
  'IN_PROGRESS': 'in_progress',
  'SUCCESS': 'success',
  'FAILED': 'failed'
}